module.exports = __webpack_public_path__ + "img/memoirerings@2x.abcca47.jpg";